export const signUpClient = {
    basicInfo: '基本情報',
    contractInfo: '申込責任書',
    companyName: '企業名',
    country: '国',
    postalCode: '郵便番号',
    companyAddress: '住所',
    representativeName: '代表者氏名',
    phoneNumber: '電話番号',
    phoneNumberTip: '(入力例：+819012345678)',
    industries: '部署名',
    contractName1: '申込責任人氏名',
    contractNumber1: '電話番号',
    contractEmail1: 'メールアドレス',
    contractName2: '契約代表者名２',
    contractNumber2: '契約代表者番号２',
    contractEmail2: '契約代表者メール２',
    mailDomain1: 'メールドメイン１',
    mailDomain2: 'メールドメイン２',
    mailDomain3: 'メールドメイン３',
    mailDomain1Tip: `(xxx@domain.co.jp のメールアドレスの場合は、"domain.co.jp"を入力してください。)`,
    moreMailDomainTip: '(複数のメールドメインを持つ場合は登録してください。)',
    contractPlan: '契約プラン',
    contractDate: '契約日',
    clientTheme: 'クライアントテーマ',
    agree: '契約プラン免責事項への同意',
    trialLabel: 'トライアルの場合はオンにしてください',
    trial: 'トライアル',
    signUp: '登録',
    contractPlanList: {
        basic: 'Basic',
        advanced: 'Advanced',
        managed: 'Managed'
    },
    warningMsg: {
        isRequired: 'を入力してください。',
        selectIsRequired: 'を選択してください。',
        mailDomainError: 'を入力指定ください。',
        typoError: '符号・英数字のみ入力してください。',
        incorrectEmailFormat: 'メール形式が正しくありません。',
        incorrectPhoneNumberFormat: '電話番号形式が正しくありません。',
        duplicatedEmail: '該当ユーザーは既に存在します。登録できません。',
        registrationSuccess: '処理が正常終了しました。',
        registrationError: '処理が失敗しました。'
    }
}
